import type { MessageDescriptor } from 'react-intl';
import type { ShowcaseUpsellAction } from './showcaseActions';
import { showcaseMessages } from './showcaseMessages';

export interface ShowcaseUpsellLine {
  /** The bold first sentence; also the title of a locked tab card (design c3). */
  lead: MessageDescriptor;
  rest: MessageDescriptor;
}

/** The purple line of the sign-up card per action (design c2 lines). */
export const SHOWCASE_UPSELL_LINES: Readonly<Record<ShowcaseUpsellAction, ShowcaseUpsellLine>> = {
  make: { lead: showcaseMessages.makeLead, rest: showcaseMessages.makeRest },
  recut: { lead: showcaseMessages.recutLead, rest: showcaseMessages.recutRest },
  aiClips: { lead: showcaseMessages.aiLead, rest: showcaseMessages.aiRest },
  upload: { lead: showcaseMessages.footageLead, rest: showcaseMessages.footageRest },
  yours: { lead: showcaseMessages.footageLead, rest: showcaseMessages.footageRest },
  newCut: { lead: showcaseMessages.cutsLead, rest: showcaseMessages.cutsRest },
  copyCut: { lead: showcaseMessages.cutsLead, rest: showcaseMessages.cutsRest },
};
